module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/krkaBN/tc-custom/9781647001131.jpg?1726519015552",
      "alt": "This image is the cover for the book Knit a Hat"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Knit a Hat\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An introduction to the wide world of knitting by way of making your own hat.")]), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v("Knitting is an excellent handcraft and something people love the world over. For crafting newbies, knitting can seem highly daunting: you need needles (but what size?), yarn (but what weight?), and a pattern (but what kind?), and very quickly knitting can start to resemble another language, tricky to navigate and even harder to master. "), _c('i', [_vm._v("Knit a Hat ")]), _vm._v("teaches you everything you need to know about the previously scary craft: the needles you’ll need, the yarn to use, and tried-and-true techniques to get you started, keep you going, and help you wrap everything up. Alanna Okun is an expert knitter and o?ers very accessible instructions: Her idea of starting with a hat rather than a long scarf is sure to make this book easy for even the wariest of beginners. Building on our crafting how-to series, Alanna welcomes readers into the knitting community and invites them to knit a hat with con?dence.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alanna Okun\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Alanna Okun is a crafter, knitter, and writer whose work has been featured in the New York Times, BuzzFeed, and more. Her first book, The Curse of the Boyfriend Sweater, debuted in May 2018. She lives in Brooklyn.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Abrams\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0